import React, { useState } from 'react';
import { Box, Stack, Typography, Button, Container, Grid, TextField, InputAdornment, IconButton, Link, CircularProgress } from '@mui/material';
import maxWeighLogo from '../assets/MaxWeighLogo.webp';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = ({ onHomeClick, onAboutClick, onContactClick }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEmailSubmit = async () => {
    if (!email) {
      alert("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const emailSubject = `New user interested with email id ${email}`;
      const emailBody = `
        <p>A new user is interested to receive the newsletter with email id:</p>
        <p><strong>Email:</strong> ${email}</p>
      `;

      const response = await fetch(
        "https://maxweighwebsiteemailfunctionapp.azurewebsites.net/api/funcemailintegration?code=kunIUQrdWU2jCZQVE4Ikm8sbVPqprIjpXeAyoLFc30LyAzFu4ffGTQ%3D%3D",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailSubject,
            emailBody,
          }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log("Email sent successfully:", result);
        alert("Thank you! Your email has been submitted.");
        setEmail("");
      } else {
        console.error("Error sending email:", response.statusText);
        alert("Failed to submit your email. Please try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while submitting your email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ backgroundColor: '#7C001F', color: 'white', pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          {/* Brand Section */}
          <Grid item xs={12} md={4}>
            <Box component="img" src={maxWeighLogo} alt="MaxWeigh Logo" sx={{ width: '180px', height: 'auto', mb: 3 }} />
            <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', lineHeight: 1.8, mb: 3, opacity: 0.9 }}>
              Max Weigh specializes in delivering high-quality weighing solutions tailored to meet the unique needs of various industries. Precision meets performance.
            </Typography>
            <Stack direction="row" spacing={2}>
              <IconButton sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}>
                <FacebookIcon />
              </IconButton>
              <IconButton sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}>
                <LinkedInIcon />
              </IconButton>
              <IconButton sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}>
                <TwitterIcon />
              </IconButton>
              <IconButton sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}>
                <InstagramIcon />
              </IconButton>
            </Stack>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, mb: 3 }}>
              Quick Links
            </Typography>
            <Stack spacing={2}>
              <Link component="button" onClick={onHomeClick} sx={{ color: 'white', textAlign: 'left', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, fontFamily: 'Inter, sans-serif' }}>
                Home
              </Link>
              <Link component="button" onClick={onAboutClick} sx={{ color: 'white', textAlign: 'left', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, fontFamily: 'Inter, sans-serif' }}>
                About Us
              </Link>
              <Link component="button" onClick={onContactClick} sx={{ color: 'white', textAlign: 'left', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, fontFamily: 'Inter, sans-serif' }}>
                Contact
              </Link>
              <Link href="#" sx={{ color: 'white', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, fontFamily: 'Inter, sans-serif' }}>
                Products
              </Link>
            </Stack>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, mb: 3 }}>
              Contact Us
            </Typography>
            <Stack spacing={2}>
              <Stack direction="row" spacing={2} alignItems="flex-start">
                <LocationOnIcon sx={{ fontSize: 20, mt: 0.5 }} />
                <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', lineHeight: 1.6 }}>
                  Office No.: 215, Panchratna Building, <br />Opp. Govinda Complex, GIDC, Char Rasta, Vapi
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <PhoneIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                  +91 9825394564
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <EmailIcon sx={{ fontSize: 20 }} />
                <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                  maxweighsystem@gmail.com
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          {/* Newsletter */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, mb: 3 }}>
              Newsletter
            </Typography>
            <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', mb: 2, opacity: 0.9 }}>
              Subscribe to get the latest updates and news.
            </Typography>
            <Stack spacing={2}>
              <TextField
                variant="outlined"
                placeholder="Your Email"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  borderRadius: 1,
                  input: { color: 'white' },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                    '&:hover fieldset': { borderColor: 'white' },
                    '&.Mui-focused fieldset': { borderColor: 'white' },
                  }
                }}
              />
              <Button
                variant="contained"
                onClick={handleEmailSubmit}
                disabled={loading}
                sx={{
                  backgroundColor: 'white',
                  color: '#7C001F',
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#f0f0f0'
                  },
                  '&.Mui-disabled': {
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    color: '#7C001F'
                  }
                }}
              >
                {loading ? <CircularProgress size={24} sx={{ color: '#7C001F' }} /> : "Subscribe"}
              </Button>
            </Stack>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mt: 8, pt: 4, textAlign: 'center' }}>
          <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', opacity: 0.7 }}>
            © {new Date().getFullYear()} Max Weigh. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
